export default "__VITE_ASSET__DIZUYFiM__";